'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fad';
var iconName = 'circle-dot';
var width = 512;
var height = 512;
var aliases = [128280,"dot-circle"];
var unicode = 'f192';
var svgPathData = ['M0 256a256 256 0 1 0 512 0 256 256 0 1 0 -512 0zm352 0a96 96 0 1 1 -192 0 96 96 0 1 1 192 0z', 'M160 256a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faCircleDot = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;